// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3W_HH","resendInfoText":"OnGoingPaymentBox_resendInfoText__1QI6K"};